/**
 * PLEKIFY CITATION SYSTEM
 * JavaScript functionality for citation popovers
 *
 * Features:
 * - Viewport-aware popover positioning (above/below)
 * - Touch device detection with bottom sheet
 * - Keyboard navigation (Tab, Enter, Escape)
 * - Click-outside dismiss
 * - Hover bridge for mouse users
 * - ARIA accessibility support
 * - Dynamic content from data attributes
 *
 * @version 1.0.0
 * @date 2026-03-31
 */

// TODO — VERIFY URL before publishing:
// GEO1, DR1, OTA1, SS1, IM1, CUR1

window.PLEKIFY_CITATIONS = {
  "C1": {
    source: "Baymard Institute",
    url: "https://baymard.com/lists/cart-abandonment-rate",
    date: "2024",
    excerpt: "Cart abandonment 70.19%; $260B recoverable; 22% cite too long/complicated checkout",
    type: "external"
  },
  "B1": {
    source: "Shopify",
    url: "https://www.shopify.com/blog/shop-pay-checkout",
    date: "2024",
    excerpt: "Shop Pay up to 50% higher conversion; 4× faster mobile; +5% presence lift",
    type: "external"
  },
  "B2": {
    source: "Chargeflow",
    url: "https://www.chargeflow.io/blog/shop-pay-statistics",
    date: "2025",
    excerpt: "Shop Pay 100M+ pre-saved buyers (conservative; estimates 150–200M)",
    type: "external"
  },
  "C4": {
    source: "Baymard Institute",
    url: "https://baymard.com/checkout-usability",
    date: "2024",
    excerpt: "Avg checkout 11.3 fields (8 needed); forced account = 19% abandonment; 35% abandon over coupon field; 42% mistype split name",
    type: "external"
  },
  "GEO1": {
    source: "Plekify synthesis of Gemini Deep Research (Baymard + GEO research)",
    url: "",
    date: "2026",
    excerpt: "Each extra pre-price step −8–12% CVR; structured/fact-dense content earns 30–40% higher AI citation rates",
    type: "secondary"
  },
  "DR1": {
    source: "Gemini Deep Research (usability synthesis)",
    url: "",
    date: "2026",
    excerpt: "Domain redirect 15–22% entry-point drop-off; 23% abandon over off-domain payment trust",
    type: "secondary"
  },
  "OTA1": {
    source: "Gemini Deep Research (SADC distribution; Tanda Tula worked example)",
    url: "",
    date: "2026",
    excerpt: "OTA commission 15–30%; safari/DMC 25–45%; lodge retains 40–55% of gross; R10,000 rack → ~R486 retained",
    type: "secondary"
  },
  "SM1": {
    source: "SiteMinder",
    url: "https://www.siteminder.com/",
    date: "2025",
    excerpt: "Direct ABV $516 vs OTA $312; cancellation 10.6% vs 21.8%; direct LTV ~1.73× OTA; +$246.84 net per shifted booking",
    type: "external"
  },
  "H1": {
    source: "SaleCycle / Statista",
    url: "https://www.salecycle.com/resources/stats/cart-abandonment-stats-and-trends/",
    date: "2024",
    excerpt: "Travel cart abandonment 80.8% avg (vs 70.2% retail); hotel 80–85%",
    type: "external"
  },
  "SS1": {
    source: "Gemini Deep Research (on-site search synthesis)",
    url: "",
    date: "2026",
    excerpt: "On-site search users convert up to 3×; 92% complete after a successful search; 81% abandon after a failed one",
    type: "secondary"
  },
  "IM1": {
    source: "Gemini Deep Research (immersive-media case studies)",
    url: "",
    date: "2026",
    excerpt: "Listings with 3D/virtual tours report ~46% higher booking conversion and up to 10× dwell time",
    type: "secondary"
  },
  "CUR1": {
    source: "Gemini Deep Research (Shopify Markets synthesis)",
    url: "",
    date: "2026",
    excerpt: "92% prefer native currency; 33% abandon USD-only; Shopify Markets lifts intl conversion up to 40%",
    type: "secondary"
  },
  "A1": {
    source: "TechCrunch",
    url: "https://techcrunch.com/2025/11/04/shopify-says-ai-traffic-is-up-7x-since-january-ai-driven-orders-are-up-11x/",
    date: "November 2025",
    excerpt: "AI traffic to Shopify up 7× since Jan 2025",
    type: "external"
  },
  "A2": {
    source: "PYMNTS",
    url: "https://www.pymnts.com/artificial-intelligence-2/2025/shopify-ai-driven-orders-surge-1100/",
    date: "November 2025",
    excerpt: "AI-driven orders up 11×",
    type: "external"
  },
  "D1": {
    source: "CNBC",
    url: "https://www.cnbc.com/2026/03/openai-instant-checkout-discontinued.html",
    date: "March 2026",
    excerpt: "OpenAI discontinued Instant Checkout (Mar 2026); Walmart ~3× lower conversion; ~12 merchants integrated",
    type: "external"
  },
  "UCP1": {
    source: "Shopify Engineering / UCP announcement",
    url: "https://www.shopify.com/news",
    date: "2026",
    excerpt: "UCP (Google + Shopify, early 2026) lets agents transact; merchant stays Merchant of Record",
    type: "external"
  },
  "T1": {
    source: "Phocuswright",
    url: "https://www.phocuswright.com/",
    date: "2026",
    excerpt: "56% of travellers used AI to plan (Phocuswright 2026), up from 24%; only 8% trust it almost always",
    type: "external"
  },
  "E1": {
    source: "Plekify Booking Friction Study",
    url: "/pages/friction-study",
    date: "June 2026",
    excerpt: "Phase 5b results: Plekify friction score 4.2; 94% success rate; 0 domain handoffs. 276 runs, 23 properties, 5 PMS platforms.",
    type: "internal"
  },
  "E4": {
    source: "Plekify Booking Friction Study",
    url: "/pages/friction-study",
    date: "June 2026",
    excerpt: "3.5 clicks to payment (Plekify)",
    type: "internal"
  },
  "K1": {
    source: "Kalibri Labs",
    url: "https://kalibrilabs.com/cope-framework",
    date: "2024",
    excerpt: "Direct booking revenue retention 95.82%; OTA booking revenue retention 82.06% (COPE Framework).",
    type: "external"
  },
  "S1": {
    source: "TechCrunch / Shopify",
    url: "https://techcrunch.com/2025/11/04/shopify-says-ai-traffic-is-up-7x-since-january-ai-driven-orders-are-up-11x/",
    date: "November 2025",
    excerpt: "AI-driven orders on Shopify up 11× since January 2025.",
    type: "external"
  }
};

(function() {
  'use strict';

  // Configuration
  const CONFIG = {
    hoverDelay: 150,           // ms before showing popover on hover
    hoverBridgeTime: 300,      // ms grace period when moving to popover
    animationDuration: 200,    // ms for fade animation
    viewportPadding: 16,       // px from viewport edges
    mobileBreakpoint: 768,     // px threshold for mobile behavior
    bottomSheetThreshold: 100  // px from bottom to trigger below positioning
  };

  // State management
  let activePopover = null;
  let activeMarker = null;
  let hoverTimeout = null;
  let bridgeTimeout = null;
  let isTouchDevice = false;
  let bottomSheet = null;
  let sheetOverlay = null;

  /**
   * Initialize the citation system
   */
  function init() {
    // Detect touch device
    isTouchDevice = detectTouchDevice();

    // Create mobile bottom sheet if needed
    if (isTouchDevice || window.innerWidth < CONFIG.mobileBreakpoint) {
      createBottomSheet();
    }

    // Bind events to all citation markers
    bindCitationEvents();

    // Global event listeners
    document.addEventListener('click', handleOutsideClick);
    document.addEventListener('keydown', handleKeydown);
    window.addEventListener('resize', handleResize);
    window.addEventListener('scroll', handleScroll, { passive: true });

    // Re-initialize on dynamic content (for Shopify sections)
    observeDynamicContent();
  }

  /**
   * Detect if device supports touch
   */
  function detectTouchDevice() {
    return (
      'ontouchstart' in window ||
      navigator.maxTouchPoints > 0 ||
      navigator.msMaxTouchPoints > 0
    );
  }

  /**
   * Create the mobile bottom sheet elements
   */
  function createBottomSheet() {
    // Only create once
    if (document.querySelector('.citation-bottom-sheet')) return;

    // Overlay
    sheetOverlay = document.createElement('div');
    sheetOverlay.className = 'citation-sheet-overlay';
    sheetOverlay.setAttribute('aria-hidden', 'true');
    sheetOverlay.addEventListener('click', closeBottomSheet);

    // Bottom sheet container
    bottomSheet = document.createElement('div');
    bottomSheet.className = 'citation-bottom-sheet';
    bottomSheet.setAttribute('role', 'dialog');
    bottomSheet.setAttribute('aria-modal', 'true');
    bottomSheet.setAttribute('aria-label', 'Citation details');

    // Close button
    const closeBtn = document.createElement('button');
    closeBtn.className = 'citation-sheet-close';
    closeBtn.setAttribute('aria-label', 'Close citation');
    closeBtn.innerHTML = '&times;';
    closeBtn.addEventListener('click', closeBottomSheet);

    // Content container
    const content = document.createElement('div');
    content.className = 'citation-sheet-content';

    bottomSheet.appendChild(closeBtn);
    bottomSheet.appendChild(content);
    document.body.appendChild(sheetOverlay);
    document.body.appendChild(bottomSheet);
  }

  /**
   * Bind events to citation markers
   */
  function bindCitationEvents() {
    const markers = document.querySelectorAll('[data-citation], [data-citation-id]');

    markers.forEach(marker => {
      // Skip if already initialized
      if (marker.hasAttribute('data-citation-init')) return;
      marker.setAttribute('data-citation-init', 'true');

      // Make focusable if not already
      if (!marker.hasAttribute('tabindex')) {
        marker.setAttribute('tabindex', '0');
      }

      // Add ARIA attributes
      marker.setAttribute('role', 'button');
      marker.setAttribute('aria-expanded', 'false');
      marker.setAttribute('aria-haspopup', 'dialog');

      // Get or create popover
      const popover = findOrCreatePopover(marker);
      if (popover) {
        const popoverId = popover.id || generateId('citation-popover');
        popover.id = popoverId;
        marker.setAttribute('aria-controls', popoverId);
      }

      // Ensure the marker uses the pill-style attribute expected by CSS
      if (!marker.hasAttribute('data-citation-id') && marker.hasAttribute('data-citation')) {
        marker.setAttribute('data-citation-id', marker.getAttribute('data-citation'));
      }

      if (isTouchDevice || window.innerWidth < CONFIG.mobileBreakpoint) {
        // Touch: tap to open bottom sheet
        marker.addEventListener('click', handleTouchClick);
        marker.addEventListener('touchend', handleTouchClick);
      } else {
        // Mouse: hover behavior
        marker.addEventListener('mouseenter', handleMouseEnter);
        marker.addEventListener('mouseleave', handleMouseLeave);
        marker.addEventListener('focus', handleFocus);
        marker.addEventListener('blur', handleBlur);
        marker.addEventListener('click', handleMarkerClick);
      }

      // Keyboard for both
      marker.addEventListener('keydown', handleMarkerKeydown);
    });
  }

  /**
   * Check if a popover has meaningful content
   */
  function hasPopoverContent(popover) {
    return !!(popover.querySelector('.citation-header, .citation-header-internal') || popover.querySelector('.citation-excerpt'));
  }

  /**
   * Find existing popover or create from data attributes
   */
  function findOrCreatePopover(marker) {
    // Check for sibling popover inside marker
    let popover = marker.querySelector('.citation-popover');
    if (popover) {
      if (hasPopoverContent(popover)) {
        return popover;
      }
      popover.remove();
    }

    // Check for next sibling
    popover = marker.nextElementSibling;
    if (popover && popover.classList.contains('citation-popover')) {
      if (hasPopoverContent(popover)) {
        return popover;
      }
      popover.remove();
    }

    // Create from data attributes
    const citationId = marker.getAttribute('data-citation-id') || marker.getAttribute('data-citation');
    const citationData = getCitationData(citationId);

    if (citationData) {
      popover = createPopoverElement(citationData);
      marker.appendChild(popover);
      return popover;
    }

    return null;
  }

  /**
   * Get citation data from registry or data attributes
   */
  function getCitationData(citationId) {
    // Check global registry first (set by Liquid)
    if (window.PLEKIFY_CITATIONS && window.PLEKIFY_CITATIONS[citationId]) {
      return window.PLEKIFY_CITATIONS[citationId];
    }

    // Check for inline data attributes
    const marker = document.querySelector(`[data-citation-id="${citationId}"], [data-citation="${citationId}"]`);
    if (marker) {
      return {
        id: citationId,
        source: marker.getAttribute('data-source') || '',
        url: marker.getAttribute('data-url') || '',
        date: marker.getAttribute('data-date') || '',
        excerpt: marker.getAttribute('data-excerpt') || '',
        favicon: marker.getAttribute('data-favicon') || '',
        type: marker.getAttribute('data-type') || 'external'
      };
    }

    return null;
  }

  /**
   * Create popover DOM element
   */
  function createPopoverElement(data) {
    const popover = document.createElement('div');
    popover.className = `citation-popover citation-${data.type || 'external'}`;
    popover.setAttribute('role', 'tooltip');
    popover.setAttribute('aria-hidden', 'true');

    let html = '';

    var headerClass = data.type === 'internal' ? 'citation-header-internal' : 'citation-header';

    // Header with favicon and source
    html += '<div class="' + headerClass + '">';
    if (data.favicon) {
      html += '<img src="' + escapeHtml(data.favicon) + '" alt="" class="citation-favicon" width="16" height="16" loading="lazy">';
    }
    html += '<span class="citation-source">' + escapeHtml(data.source) + '</span>';
    if (data.date) {
      html += '<span class="citation-date">' + escapeHtml(data.date) + '</span>';
    }
    html += '</div>';

    // Excerpt
    if (data.excerpt) {
      html += '<div class="citation-excerpt">' + escapeHtml(data.excerpt) + '</div>';
    }

    // Link
    if (data.url) {
      html += '<a href="' + escapeHtml(data.url) + '" class="citation-link" target="_blank" rel="noopener">View source &rarr;</a>';
    }

    popover.innerHTML = html;
    return popover;
  }

  /**
   * Handle mouse enter on marker
   */
  function handleMouseEnter(event) {
    const marker = event.currentTarget;
    clearTimeout(hoverTimeout);
    clearTimeout(bridgeTimeout);

    hoverTimeout = setTimeout(() => {
      showPopover(marker);
    }, CONFIG.hoverDelay);
  }

  /**
   * Handle mouse leave on marker
   */
  function handleMouseLeave(event) {
    clearTimeout(hoverTimeout);

    // Bridge timeout for moving to popover
    bridgeTimeout = setTimeout(() => {
      const popover = activePopover;
      if (popover && !popover.matches(':hover')) {
        hidePopover();
      }
    }, CONFIG.hoverBridgeTime);
  }

  /**
   * Handle focus on marker
   */
  function handleFocus(event) {
    const marker = event.currentTarget;
    showPopover(marker);
  }

  /**
   * Handle blur on marker
   */
  function handleBlur(event) {
    // Delay to check if focus moved to popover
    setTimeout(() => {
      if (activePopover && !activePopover.contains(document.activeElement)) {
        hidePopover();
      }
    }, 10);
  }

  /**
   * Handle click on marker (desktop)
   */
  function handleMarkerClick(event) {
    event.preventDefault();
    const marker = event.currentTarget;

    if (activeMarker === marker && activePopover) {
      hidePopover();
    } else {
      showPopover(marker);
    }
  }

  /**
   * Handle touch click (mobile)
   */
  function handleTouchClick(event) {
    event.preventDefault();
    event.stopPropagation();

    const marker = event.currentTarget;
    const citationId = marker.getAttribute('data-citation-id') || marker.getAttribute('data-citation');
    const citationData = getCitationData(citationId);

    if (citationData) {
      openBottomSheet(citationData, marker);
    }
  }

  /**
   * Handle keydown on marker
   */
  function handleMarkerKeydown(event) {
    const marker = event.currentTarget;

    switch (event.key) {
      case 'Enter':
      case ' ':
        event.preventDefault();
        if (isTouchDevice || window.innerWidth < CONFIG.mobileBreakpoint) {
          handleTouchClick(event);
        } else {
          if (activeMarker === marker && activePopover) {
            hidePopover();
          } else {
            showPopover(marker);
          }
        }
        break;

      case 'Escape':
        if (activePopover) {
          hidePopover();
          marker.focus();
        }
        break;
    }
  }

  /**
   * Show popover for a marker
   */
  function showPopover(marker) {
    // Hide any existing popover
    if (activePopover && activeMarker !== marker) {
      hidePopover();
    }

    const popover = findOrCreatePopover(marker);
    if (!popover) return;

    // Position the popover
    positionPopover(marker, popover);

    // Show with animation
    popover.classList.add('is-visible');
    popover.setAttribute('aria-hidden', 'false');
    marker.setAttribute('aria-expanded', 'true');

    // Set up popover hover events
    popover.addEventListener('mouseenter', handlePopoverEnter);
    popover.addEventListener('mouseleave', handlePopoverLeave);

    activePopover = popover;
    activeMarker = marker;
  }

  /**
   * Hide the active popover
   */
  function hidePopover() {
    if (!activePopover) return;

    activePopover.classList.remove('is-visible');
    activePopover.setAttribute('aria-hidden', 'true');

    if (activeMarker) {
      activeMarker.setAttribute('aria-expanded', 'false');
    }

    // Remove popover events
    activePopover.removeEventListener('mouseenter', handlePopoverEnter);
    activePopover.removeEventListener('mouseleave', handlePopoverLeave);

    activePopover = null;
    activeMarker = null;
  }

  /**
   * Position popover relative to marker
   */
  function positionPopover(marker, popover) {
    const markerRect = marker.getBoundingClientRect();
    const popoverRect = popover.getBoundingClientRect();
    const viewportHeight = window.innerHeight;
    const viewportWidth = window.innerWidth;

    // Reset positioning classes
    popover.classList.remove('position-below');

    // Calculate available space
    const spaceAbove = markerRect.top;
    const spaceBelow = viewportHeight - markerRect.bottom;
    const popoverHeight = popoverRect.height || 150; // Estimate if not rendered

    // Determine vertical position
    if (spaceAbove < popoverHeight + CONFIG.viewportPadding &&
        spaceBelow > spaceAbove) {
      // Position below
      popover.classList.add('position-below');
    }

    // Horizontal positioning handled by CSS (centered on marker)
    // But check for edge overflow
    const markerCenter = markerRect.left + (markerRect.width / 2);
    const popoverWidth = popoverRect.width || 280;
    const halfWidth = popoverWidth / 2;

    if (markerCenter - halfWidth < CONFIG.viewportPadding) {
      // Too close to left edge
      popover.style.left = `${CONFIG.viewportPadding - markerRect.left}px`;
      popover.style.transform = 'none';
    } else if (markerCenter + halfWidth > viewportWidth - CONFIG.viewportPadding) {
      // Too close to right edge
      popover.style.left = 'auto';
      popover.style.right = `${markerRect.right - viewportWidth + CONFIG.viewportPadding}px`;
      popover.style.transform = 'none';
    } else {
      // Reset to default centered positioning
      popover.style.left = '';
      popover.style.right = '';
      popover.style.transform = '';
    }
  }

  /**
   * Handle mouse enter on popover
   */
  function handlePopoverEnter() {
    clearTimeout(bridgeTimeout);
  }

  /**
   * Handle mouse leave on popover
   */
  function handlePopoverLeave() {
    hidePopover();
  }

  /**
   * Open mobile bottom sheet
   */
  function openBottomSheet(data, triggerElement) {
    if (!bottomSheet || !sheetOverlay) {
      createBottomSheet();
    }

    const content = bottomSheet.querySelector('.citation-sheet-content');

    // Build content
    let html = '';

    // Header
    html += '<div class="sheet-header">';
    if (data.favicon) {
      html += `<img src="${escapeHtml(data.favicon)}" alt="" class="sheet-favicon" width="24" height="24">`;
    }
    html += `<div class="sheet-source">${escapeHtml(data.source)}</div>`;
    if (data.date) {
      html += `<div class="sheet-date">${escapeHtml(data.date)}</div>`;
    }
    html += '</div>';

    // Excerpt
    if (data.excerpt) {
      html += `<div class="sheet-excerpt">${escapeHtml(data.excerpt)}</div>`;
    }

    // Link
    if (data.url) {
      html += `<a href="${escapeHtml(data.url)}" class="sheet-link" target="_blank" rel="noopener">View source &rarr;</a>`;
    }

    content.innerHTML = html;

    // Show
    sheetOverlay.classList.add('is-visible');
    bottomSheet.classList.add('is-visible');
    document.body.style.overflow = 'hidden';

    // Focus management
    bottomSheet.setAttribute('aria-hidden', 'false');
    const closeBtn = bottomSheet.querySelector('.citation-sheet-close');
    if (closeBtn) closeBtn.focus();

    // Store trigger for focus return
    bottomSheet.dataset.trigger = triggerElement ? 'true' : 'false';
    if (triggerElement) {
      window._citationTrigger = triggerElement;
    }
  }

  /**
   * Close mobile bottom sheet
   */
  function closeBottomSheet() {
    if (!bottomSheet || !sheetOverlay) return;

    sheetOverlay.classList.remove('is-visible');
    bottomSheet.classList.remove('is-visible');
    bottomSheet.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';

    // Return focus
    if (window._citationTrigger) {
      window._citationTrigger.focus();
      window._citationTrigger = null;
    }
  }

  /**
   * Handle click outside popover
   */
  function handleOutsideClick(event) {
    if (!activePopover) return;

    const target = event.target;

    // Check if click is outside marker and popover
    if (!activeMarker.contains(target) && !activePopover.contains(target)) {
      hidePopover();
    }
  }

  /**
   * Handle global keydown
   */
  function handleKeydown(event) {
    if (event.key === 'Escape') {
      if (bottomSheet && bottomSheet.classList.contains('is-visible')) {
        closeBottomSheet();
      } else if (activePopover) {
        hidePopover();
        if (activeMarker) activeMarker.focus();
      }
    }
  }

  /**
   * Handle window resize
   */
  function handleResize() {
    // Close popover on resize to prevent positioning issues
    if (activePopover) {
      hidePopover();
    }

    // Check if we need to switch to mobile mode
    const isMobile = window.innerWidth < CONFIG.mobileBreakpoint;
    if (isMobile && !bottomSheet) {
      createBottomSheet();
    }
  }

  /**
   * Handle scroll - reposition popover if visible
   */
  function handleScroll() {
    if (activePopover && activeMarker) {
      positionPopover(activeMarker, activePopover);
    }
  }

  /**
   * Observe for dynamically added citations
   */
  function observeDynamicContent() {
    if (!window.MutationObserver) return;

    const observer = new MutationObserver((mutations) => {
      let shouldRebind = false;

      mutations.forEach((mutation) => {
        if (mutation.addedNodes.length) {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              if (node.hasAttribute('data-citation') ||
                  node.querySelector('[data-citation]')) {
                shouldRebind = true;
              }
            }
          });
        }
      });

      if (shouldRebind) {
        bindCitationEvents();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  /**
   * Generate unique ID
   */
  function generateId(prefix) {
    return `${prefix}-${Math.random().toString(36).substr(2, 9)}`;
  }

  /**
   * Escape HTML to prevent XSS
   */
  function escapeHtml(str) {
    if (!str) return '';
    const div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /**
   * Public API
   */
  window.PlekifyCitations = {
    init: init,
    showPopover: function(citationId) {
      const marker = document.querySelector(`[data-citation="${citationId}"]`);
      if (marker) showPopover(marker);
    },
    hidePopover: hidePopover,
    closeBottomSheet: closeBottomSheet,
    refresh: bindCitationEvents
  };

  // Auto-initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
